export interface cv_Modifier1 {
    C_Modifier1_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    IsEndState: boolean;
    IsPermanent: boolean;
    ModifiedBy: string;
    Modifier1: string;
    SortOrder: number | null;
    Version: number;
}
